import { trimsConstants } from "../../constants";

export function trims(state = {}, action) {
  switch (action.type) {
    // get all
    case trimsConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case trimsConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case trimsConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case trimsConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case trimsConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case trimsConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case trimsConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case trimsConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case trimsConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case trimsConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case trimsConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case trimsConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case trimsConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
